import * as i0 from '@angular/core';
import { InjectionToken, Injectable } from '@angular/core';
import { get } from 'lodash-es';

const AXGlobalDefaultConfig = {};
const AX_GLOBAL_CONFIG = new InjectionToken('AX_GLOBAL_CONFIG', {
    providedIn: 'root',
    factory: () => AXGlobalDefaultConfig,
});

class AXConfigService {
    /**
     * @ignore
     */
    constructor(injector) {
        this.injector = injector;
    }
    get(key, defaultValue) {
        const v1 = this.injector.get(AX_GLOBAL_CONFIG);
        const parts = key.split('.');
        const tokenName = parts.slice(0, parts.length - 1).join('.');
        const providerToken = get(v1, tokenName);
        const v2 = this.injector.get(providerToken);
        return get(v2, parts[parts.length - 1], defaultValue);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.0.2", ngImport: i0, type: AXConfigService, deps: [{ token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.0.2", ngImport: i0, type: AXConfigService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.0.2", ngImport: i0, type: AXConfigService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i0.Injector }] });

/**
 * Generated bundle index. Do not edit.
 */

export { AXConfigService, AXGlobalDefaultConfig, AX_GLOBAL_CONFIG };
